import http from '../libs/http';
import { guideVideoType, visaOpenClassType } from '../constants/knowledge-constants';

export default {

  // 获取签证知识首页数据
  getVisaKnowledgeHomepage() {
    return http.post('/sys/visa_knowledge_homepage', {});
  },

  // 加载课程详情
  loadVideoClassDetail(id) {
    return http.post('/sys/visa_video_query', { id });
  },

  // 查询视频列表
  visaVideoBriefQuery(params) {
    return http.post('/sys/visa_video_brief_query', params);
  },

  // 查询文章列表
  visaArticleBriefQuery(params) {
    return http.post('/sys/article_brief_query', params);
  },

  // 格式化引导视频列表
  formatGuideVideos(guideVideosObj) {
    const result = [];
    const keys = Object.keys(guideVideosObj);

    keys.forEach((typeId) => {
      result.push({
        type_id: typeId,
        type_name: guideVideoType[typeId - 1],
        type_arr: guideVideosObj[typeId],
      });
    });

    return result;
  },

  // 格式化签证公开课列表
  formatVisaOpenClasses(openClassesObj) {
    const result = [];
    const keys = Object.keys(openClassesObj);
    const visaOpenClassTypeAll = ['推荐课程', ...visaOpenClassType];
    keys.forEach((typeId) => {
      result.push({
        type_id: typeId,
        type_name: visaOpenClassTypeAll[typeId],
        type_arr: openClassesObj[typeId],
      });
    });

    return result;
  },

  formatViewecCount(number) {
    return number > 999
      ? `${Number((number / 1000).toFixed(1))}k`
      : number;
  },
};



// WEBPACK FOOTER //
// ./src/services/knowledge-service.js